export default __webpack_public_path__ + "static/media/Bethany 9781846164903.ee5c3397.jpg";